import "./App.css";
import Randomquotes from "./components/RandomQuotes/RandonQuotes";

function App() {
  return (
    <div>
      <Randomquotes />
    </div>
  );
}

export default App;
